import React, { FC } from 'react';
import MuiPaper, { PaperProps as MuiPaperProps } from '@material-ui/core/Paper';
import { Uds } from '../../types';

export type PaperProps = Uds<MuiPaperProps & {}>;

export const Paper: FC<React.PropsWithChildren<PaperProps>> = ({ dataTest, ...props }) => (
  <MuiPaper data-test={dataTest} {...props} />
);
